import { useQuery } from 'react-query';

import { APIBaseChronos } from '../hosts';
import { QueryEntity } from '../types';
import useGetFetchConfig from '../useGetFetchConfig';

export const useGetAllDocumentsCase = (matterId: string | null) => {
  const { fetchConfigGET } = useGetFetchConfig();

  return useQuery<{ id: string }>(
    [QueryEntity.Case, 'all-documents', matterId],
    () => {
      return fetch(`${APIBaseChronos}/api/matters/${matterId}/all-documents-case`, fetchConfigGET).then((res) => {
        return res.json();
      });
    },
    {
      enabled: !!matterId,
      refetchOnWindowFocus: false,
    },
  );
};
